import React from 'react';

import { connect } from 'react-redux';
import { reduxForm, FieldArray } from 'redux-form';

import { formName, mapStateToProps } from './';

import withIntl from '../../../../../../shared/intl-hoc';

import AffiliatePayoutSystemSettings from './affiliate-payout-system-settings/main';

function PayoutSettingsForm({ intl, pristine, submitting, handleSubmit, ...props }) {
	return (
		<form
			className='ui-form affiliate-profile__settings-form'
			onSubmit={handleSubmit}
		>
			<FieldArray
				name='affiliatePayoutSystemSettings'
				component={AffiliatePayoutSystemSettings}
				payoutSystems={props.payoutSystems}
				removeSystem={props.removeSystem}
				changeField={props.change}
				allowedPayoutSystems={props.allowedPayoutSystems}
			/>
			<div className='ui-form__element'>
				<button
					className='ui-btn ui-btn-primary'
					disabled={pristine || submitting}
				>
					{intl('Save')}
				</button>
			</div>
		</form>
	);
}

const Form = connect(mapStateToProps)(withIntl(PayoutSettingsForm));

export default reduxForm({ form: formName, enableReinitialize: true })(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/payout-settings/payout-settings-form/main.js